module.exports = __webpack_public_path__ + "static/media/1-16.b19faee2.mp3";